// test899
(899 && 0);
